import React, { useState } from "react";
import "../custom.css";

const ImageCarousel = ({ images }) => {
  const [current, setCurrent] = useState(0);
  if (!images || images.length === 0) return null;

  const goToPrev = (e) => {
    e.stopPropagation();
    setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };
  const goToNext = (e) => {
    e.stopPropagation();
    setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div
      className="image-carousel"
      style={{ position: "relative", textAlign: "center", marginBottom: 16 }}
    >
      <img
        src={images[current]}
        alt={`Asset image ${current + 1}`}
        style={{
          maxWidth: "100%",
          maxHeight: 240,
          borderRadius: 8,
          boxShadow: "var(--box-shadow)",
        }}
      />
      {images.length > 1 && (
        <>
          <button
            className="carousel-btn prev"
            onClick={goToPrev}
            style={{
              position: "absolute",
              left: 8,
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 2,
            }}
            aria-label="Previous image"
          >
            &#8592;
          </button>
          <button
            className="carousel-btn next"
            onClick={goToNext}
            style={{
              position: "absolute",
              right: 8,
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 2,
            }}
            aria-label="Next image"
          >
            &#8594;
          </button>
        </>
      )}
      <div style={{ marginTop: 8, fontSize: 13, color: "#64748b" }}>
        {current + 1} / {images.length}
      </div>
    </div>
  );
};

export default ImageCarousel;
